module.exports = __webpack_public_path__ + "static/media/bankex.f9277062.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/hackathon/bankex.png
// module id = 436
// module chunks = 0